import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { AlertBox, CardButton, Pill } from 'components';
import { PendingChangesModal } from './components';
import { BenefitsCardStyled } from 'features/MyBenefits/MyBenefitsStyled';
import { useLifeEventChangesQuery } from 'queries';

interface PendingChangesSectionProps {
  lifeEventId: string;
  firstName: string;
  startsOnDate: Date;
  endsOnDate: Date;
}

export const PendingChangesSection = ({
  lifeEventId,
  firstName,
  startsOnDate,
  endsOnDate,
}: PendingChangesSectionProps) => {
  const { t } = useTranslation('pages.benefits');
  const [changesModalOpen, setChangesModalOpen] = useState<number | undefined>(
    undefined
  );
  const isScreenSmall = window.innerWidth < 744;

  const { data: lifeEventChanges, isLoading: isLoadingLifeEventChanges } =
    useLifeEventChangesQuery({
      enabled: true,
      lifeEventId: lifeEventId,
    });

  const handleOpenModal = (index: number) => {
    setChangesModalOpen(index);
  };

  const lifeEventChangedPlans = lifeEventChanges?.data.filter(
    (benefitChanges) => {
      return (
        benefitChanges.changed === true &&
        startsOnDate.valueOf() <=
          new Date(benefitChanges.plan_year_starts_on).valueOf() &&
        new Date(benefitChanges.plan_year_starts_on).valueOf() <=
          endsOnDate.valueOf()
      );
    }
  );

  if (!lifeEventChangedPlans || lifeEventChangedPlans.length === 0) {
    return <></>;
  }

  return (
    <>
      <AlertBox
        title={t('pendingChanges.lePendingApproval')}
        innerText={t('pendingChanges.lePendingText')}
      />
      <BenefitsCardStyled className="p-5 mb-5 mt-4">
        <h2>{t('pendingChanges.pendingTitle')}</h2>
        {!isLoadingLifeEventChanges &&
          lifeEventChangedPlans.map((benefitChanges, index) => {
            return (
              <div key={`pending-changes-button-${index}`} className="mb-2_5">
                <CardButton
                  handleClick={() => handleOpenModal(index)}
                  id={`pending-changes-button-${index}`}
                  dataTestId={`pending-changes-button-${index}`}
                  key={`pending-changes-button-${index}`}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="body1 semiBold text-left">
                      {benefitChanges.name}
                    </div>
                    {!isScreenSmall ? (
                      <Pill
                        text={t('pendingChanges.covPending')}
                        color="#FFDBA1"
                      />
                    ) : (
                      <div />
                    )}
                  </div>
                </CardButton>
                <PendingChangesModal
                  id={`pending-changes-modal-${index}`}
                  key={`pending-changes-modal-${index}`}
                  index={index}
                  firstName={firstName}
                  modalOpen={changesModalOpen}
                  setModalOpen={setChangesModalOpen}
                  benefitChanges={benefitChanges}
                />
              </div>
            );
          })}
      </BenefitsCardStyled>
    </>
  );
};
